{
  "title": "Gebruikersprofiel Overzicht",
  "title_Agrifirm": "Gebruikersprofiel",
  "title_Agravis": "Avidata Profile",
  "message": "Hallo wereld, je gebruikersprofiel overzicht applicatie werkt!",
  "exampleModule": "Voorbeeld module",
  "home": "Home",
  "profile": "Authenticatie Profiel",
  "information": "Informatie",
  "search": "Zoek bij email, voornaam of achternaam",
  "search_profile": "Zoek op volledig e-mailadres en druk op ENTER",
  "licenses": "Rollen en Licenties",
  "not_found": "Het profiel is niet gevonden",
  "basic_information": "Basis informatie",
  "user_preferences": "Gebruiker Voorkeuren",
  "developer_tools": "Hulpmiddelen voor ontwikkelaars",
  "labresults": "Lab resultaten",
  "labResults_searchLabResults": "Zoek labresultaten op: lab resultaat, kuil omschrijving, Eurofins- of Ubn nummer",
  "labResults_searchLabResultsButton": "Zoek labresultaten",
  "labResults_labResultId": "Labresultaat Id",
  "labResults_description": "Omschrijving",
  "labResults_labId": "Lab Id",
  "labResults_updated": "Verwerkingsdatum",
  "labResults_statusDescription": "Status",
  "ToBeProcessed": "Nog te verwerken",
  "NotValidForProcessing": "Afgekeurd",
  "ReadyForProcessing": "Klaar om verwerkt te worden",
  "Processing": "Verwerken",
  "Processed": "Verwerkt",
  "ProcessingFailed": "Verwerking mislukt",
  "labResults_reason": "Reden",
  "labResults_searchNotFound": "Kan geen labresultaten vinden.",
  "labResults_searchError": "De labresultaten kunnen niet worden geladen.",
  "app_wizard": "Dev App Wizard",
  "business_partner": "Business partner (Not for Use)",
  "businessPartnerBackoffice": "Klanten en locaties",
  "businessPartnerBackoffice_searchBusinessPartners": "Zoek klanten en of locaties op: N.A.W., UBN, BRS, Eurofins of op KAT",
  "businessPartnerBackoffice_searchBusinessPartnersButton": "Zoek resultaten",
  "businessPartnerBackoffice_id": "Id",
  "businessPartnerBackoffice_type": "Type",
  "businessPartnerBackoffice_name": "Naam",
  "businessPartnerBackoffice_street": "Straat",
  "businessPartnerBackoffice_postalCode": "Postcode",
  "businessPartnerBackoffice_ubn": "Ubn",
  "businessPartnerBackoffice_brs": "Brs",
  "businessPartnerBackoffice_oneSap": "OneSap",
  "businessPartnerBackoffice_sapLegacyFeedId": "SapFeedId",
  "businessPartnerBackoffice_sapLegacyPlantId": "SapPlantId",
  "businessPartnerBackoffice_eurofins": "Eurofins",
  "businessPartnerBackoffice_kat": "Kat",
  "businessPartnerBackoffice_searchNotFound": "Kan geen klanten en of locaties vinden.",
  "businessPartnerBackoffice_searchError": "De klanten en of locaties kunnen niet worden geladen.",
  "jwt_token": "JWT Token",
  "dev_api_tool": "Dev API Tool",
  "wizard_application": "Applicatie",
  "wizard_applicationDescription": "Application Omschrijving",
  "wizard_applicationGroup": "Applicatie groep",
  "wizard_applicationGroupName": "Applicatie Groep Naam",
  "wizard_applicationGroups": "Applicatie groepen",
  "wizard_applicationGroupTitled": "Application Group Naam:",
  "wizard_applicationName": "Applicatie Naam",
  "wizard_applicationRoles": "Applicatie Rollen",
  "wizard_applicationTitled": "Applicatie Naam:",
  "wizard_back": "Vorige",
  "wizard_complete": "Voltooien",
  "wizard_createMessage": "U maakt het volgende aan :",
  "wizard_deleteApplicationGroupSuccessMessage": "De applicatie groep is succesvol verwijdert",
  "wizard_deleteApplicationSuccessMessage": "De applicatie is succesvol verwijdert",
  "wizard_description": "Omschrijving",
  "wizard_next": "Volgende",
  "wizard_registrationApplicationGroupSuccessMessage": "De Applicatie Groep is succesvol geregistreerd",
  "wizard_registrationSuccessMessage": "De Applicatie is succesvol geregistreerd",
  "wizard_reset": "Ongedaan maken",
  "wizard_step1EnterApplicationGroupName": "Stap1: Voerin Applicatie Groep Naam",
  "wizard_step1SelectApplication": "Stap1: Selecteer Applicatie",
  "wizard_step1SelectApplicationGroup": "Stap1: Selecteer een Applicatie Groep",
  "wizard_step2CreateApplicationName": "Stap 2: Voerin Applicatie Naam",
  "wizard_step2DeleteApplication": "Stap 2: Verwijder de Applicatie",
  "wizard_step2DeleteApplicationGroup": "Stap 2: Verwijder de Applicatie Groep",
  "wizard_step2RegisterApplicationGroup": "Stap 2: Registreer de Applicatie Groep",
  "wizard_step3Complete": "Step 3: Complete",
  "wizard_step3EnterApplicationDescription": "Stap 3: Voerin Applicatie Omschrijving",
  "wizard_step4SelectApplicationRole": "Stap 4: Selecteer Standaard Applicatie Rol",
  "wizard_step5SelectApplicationRole": "Stap 5: Selecteer een niet toegestaan Profieltype",
  "wizard_step6RegisterApplication": "Stap 6: Registreer de Applicatie",
  "wizard_step7Complete": "Stap 7: Voltooien",
  "wizard_theApplication": "De Applicatie:",
  "wizard_underApplicationGroup": "Onder de Applicatie Groep",
  "wizard_withDefaultRoleApplicationRoleName": "Met de standaard Applicatie Rol",
  "wizard_withDisallowedRoleApplicationProfileType": "Met een niet toegestane Profieltype",
  "wizard_youAreAboutToDelete": "U wilt het volgende verwijderen :",
  "use_my_email": "Mijn e-mail"
}
